import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { lastValueFrom } from 'rxjs';
import { ProjectItem, OutlineItem } from 'src/app/shared/models/base.models';
import { ApiService } from 'src/app/shared/services/api.service';
import { CreateSpaceDto } from './dto/create-space.dto';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-create-space-modal',
  templateUrl: './create-space-modal.component.html',
  styleUrls: ['./create-space-modal.component.css']
})
export class CreateSpaceModalComponent {
  form = new FormGroup({});
  model = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      props: {
        attributes: {class: 'form-control form-control-solid form-control-lg'},
        label: 'Space Name',
        placeholder: 'Name your space',
        required: true,
      }
    },
    {
      key: 'description',
      type: 'textarea',
      props: {
        attributes: {class: 'form-control form-control-solid form-control-lg h-100px'},
        label: 'Description',
        placeholder: 'Write a Description (optional)',
        required: false,
      }
    }
  ];


  @ViewChild('spaceCreationModal') modalContent: TemplateRef<any>;
  @Input() modalRef: NgbModalRef;

  @Input('opener') set modalOpener (value: boolean) {
    if (!!value) {
      this.open();
    }
   }

   @Output() openerChange = new EventEmitter<boolean>();

   @Output() itemCreated = new EventEmitter<ProjectItem>();



   constructor(
    private api: ApiService,
   private modalService: NgbModal,
   private toastr: ToastrService
 ) {}


 async onSubmit(data) {
  console.log(data);
  if (this.form.valid) {
    console.log(data);
    let newSpacePayload: CreateSpaceDto = {
      name: data.name,
      description: data.description
    }
    let newSpace = await this.createSpace(newSpacePayload);

    this.closeModal();
    this.itemCreated.emit(newSpace);
  } else {
    this.toastr.error(
      'Please fill out all required fields before submitting.'
    );
  }
}


async createSpace(payload: CreateSpaceDto) {
  // let request$ = this.api.createProject(payload);
  // let response = await lastValueFrom(request$);

  // console.log(response);
  // return response;
  return null;
}
 resetEverything() {

 }

 closeModal() {
  this.modalRef.dismiss();
  this.openerChange.emit(false);
}

async onOpenModal() {
  this.resetEverything();
}

     // Modal Open
     async open(content?) {
      this.onOpenModal();
      this.modalRef = this.modalService.open(this.modalContent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        backdrop: 'static',
        centered: true,
        animation: true,
  windowClass: 'global-modal-class modal-animate-in',
      });
    }

}
